
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/fills?${queryString}`);
    return response.data;
  },

  async add(payload) {
    // Check if payload is FormData (for file uploads)
    if (payload instanceof FormData) {
      const response = await https.post(`/fills`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      // For JSON payloads
      const response = await https.post(`/fills`, payload);
      return response.data;
    }
  },

  async update(id, payload) {
    // Check if payload is FormData (for file uploads)
    if (payload instanceof FormData) {
      const response = await https.post(`/fills/${id}`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      // For JSON payloads, use PUT
      const response = await https.post(`/fills/${id}`, payload);
      return response.data;
    }
  },
  async deleteById(id) {
    const response = await https.delete(`/fills/${id}`);
    return response.data;
  },
  async import(file) {
    const formData = new FormData();
    formData.append('excel_file', file);
    const response = await https.post(`/fills/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
});

